<template>
  <div>
    <div
      class="effect-menu-toggle horizontal"
      @click="handleClickIcon"
      @mouseover="handleHoverEffectMenuToggleIcon"
      @mouseleave="() => {
        showEffectTooltip = false
      }"
    >
      <img
        src="@/assets/images/icon/confetti-white.svg"
        class="text-base-70 effect-icon"
        :class="{
          'white-icon': slideActive.textColour !== '#ffffff',
        }"
      >
    </div>
    <div
      v-if="showEffectMenu"
      class="effect-menu"
      :class="{
        'has-chat': isLiveChatVisible,
        'no-chat': !isLiveChatVisible,
        'white': isTextColourWhite,
        'black': !isTextColourWhite,
      }"
      @mouseleave="() => {
        showEffectMenu = false,
        showEffectTooltip = false
      }"
      @focusout="handleFocusOutEffectMenu"
      v-click-outside="handleFocusOutEffectMenu"
    >
      <span
        class="effect-header"
        :class="{
          'white': isTextColourWhite,
          'black': !isTextColourWhite,
        }"
      >
        <span class="icon">
          <img
            src="@/assets/images/effects-menu/confetti-white.svg"
            :class="{
              'white-icon': slideActive.textColour !== '#ffffff',
            }"
          >
        </span>
        <span class="text">Effects</span>
      </span>
      <ul>
        <li>
          <span
            class="effect-item"
            :class="{'effect-item-disable' : (currentlyPlayingEffect.length > 0
              && currentlyPlayingEffect !== 'c')}"
            @click="handleEffectItemClicked('c')"
          >
            <span class="icon">
              <img src="@/assets/images/effects-menu/confetti-color.svg">
            </span>
            <span class="text">Confetti</span>
            <span class="hot-key">C</span>
          </span>
        </li>
        <li>
          <span
            class="effect-item"
            :class="{'effect-item-disable' : (currentlyPlayingEffect.length > 0
              && currentlyPlayingEffect !== 'h')}"
            @click="handleEffectItemClicked('h')"
          >
            <span class="icon">
              <img src="@/assets/images/effects-menu/hand-clap.svg">
            </span>
            <span class="text">Hand Clap</span>
            <span class="hot-key">H</span>
          </span>
        </li>
        <li>
          <span
            class="effect-item"
            :class="{'effect-item-disable' : (currentlyPlayingEffect.length > 0
              && currentlyPlayingEffect !== 'd')}"
            @click="handleEffectItemClicked('d')"
          >
            <span class="icon">
              <img src="@/assets/images/effects-menu/drum-roll-color.svg">
            </span>
            <span class="text">Drumroll</span>
            <span class="hot-key">D</span>
          </span>
        </li>
      </ul>
    </div>
    <div
      v-if="showEffectTooltip"
      class="effect-tooltip"
      :class="{
        'has-chat': isLiveChatVisible,
        'no-chat': !isLiveChatVisible
      }"
    >
      Spice things up with effects!
      <div
        class="effect--tooltip__tip"
        :class="{
          'has-chat': isLiveChatVisible,
          'no-chat': !isLiveChatVisible
        }"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import QuizStatuses from '@/constant/QuizStatuses'
import EventBus from '@/eventBus'
import Util from '@/util'

export default {
  data() {
    return {
      showEffectMenu: false,
      showEffectTooltip: false,
      currentlyPlayingEffect: '',
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters(['isPresenting']),
    isLiveChatVisible() {
      return this.presentation.isEnableChat &&
      !this.presentation.audiencePacing &&
      !this.presentation.privateMode &&
        (this.isQuizSlide ||
        this.isLeaderboardScreen ||
        this.isQRCodeSlide) &&
        this.isPresenting &&
        !this.isSharingView
    },
    isSharingView() {
      return this.$store.state.sharePresentation
    },
    isLeaderboardScreen() {
      return this.slideActive.type === 'leaderboard'
    },
    isQRCodeSlide() {
      const { type } = this.slideActive
      return type === 'qrcode' && this.$store.state.presentation.slides.some((slide) => slide.type === 'pickAnswer')
    },
    isQuizSlide() {
      const { type, quizStatus } = this.slideActive
      return type === 'pickAnswer' && (
        quizStatus === QuizStatuses.LOBBY_SCREEN ||
        quizStatus === QuizStatuses.RESULT_SCREEN
      )
    },
    isTextColourWhite() {
      return this.slideActive.textColour === '#ffffff'
    },
  },
  watch: {
    '$store.state.slideActive': function slideActiveChangeWatcher() {
      this.showEffectMenu = false
      this.showEffectTooltip = false
    },
    '$store.getters.isPresenting': function isPresentingWatcher(isPresenting) {
      if (!isPresenting) {
        this.showEffectMenu = false
        this.showEffectTooltip = false
      }
    },
  },
  mounted() {
    EventBus.$on('effect-wrapper-hided', () => {
      this.currentlyPlayingEffect = ''
    })
    EventBus.$on('effect-wrapper-showed', (key) => {
      this.currentlyPlayingEffect = key
    })
  },
  destroyed() {
    EventBus.$off('effect-wrapper-hided')
    EventBus.$off('effect-wrapper-showed')
  },
  methods: {
    handleEffectItemClicked(key) {
      this.currentlyPlayingEffect = key
      EventBus.$emit('effect-menu-clicked', key)
    },
    handleHoverEffectMenuToggleIcon() {
      this.showEffectTooltip = true
      this.showEffectMenu = false
      const { type, slideType } = this.slideActive
      const slideName = Util.getCorrectSlideTypeName(type, slideType)
      Util.gaTrackEvent('Presenting Mode', 'Nav > Effects legend > Hover', '', '', {
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        slideType: slideName,
      })
    },
    handleClickIcon() {
      this.showEffectMenu = !this.showEffectMenu
      this.showEffectTooltip = false
      const { type, slideType } = this.slideActive
      const slideName = Util.getCorrectSlideTypeName(type, slideType)
      Util.gaTrackEvent('Presenting Mode', 'Nav > Effects legend > Clicked', '', '', {
        presentationid: this.presentation.id,
        slideId: this.slideActive.id,
        slideType: slideName,
      })
    },
    handleFocusOutEffectMenu() {
      this.showEffectMenu = false
      this.showEffectTooltip = false
    },
  },
}
</script>
<style scoped lang='scss'>
.white-icon {
  filter: invert(1);
}
.effect-menu-toggle {
  position: relative;
  max-width: 2rem;
  cursor: pointer;
}
.effect-icon {

}
.effect-menu {
  --effect-menu-width: 14rem;
  --effect-menu-height: 10.75rem;
  position: absolute;
  color: rgba(255, 255, 255, 1);
  width: var(--effect-menu-width);
  height: var(--effect-menu-height);
  text-align: center;
  border-radius: 8px;
  font-family: 'Nunito';
  cursor: initial;
  bottom: 3.5rem;
  display: block;
  padding-bottom: 0px;
  left: 50%;
  transform: translateX(-50%);

  &.white {
    background: rgba(24, 25, 27, 0.7);
    .text {
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      color: #FFFFFF;
    }
    .hot-key {
      text-align: center;
      margin: 0.5rem;
      border-radius: 4px;
      background: rgb(82, 95, 127);
      font-size: 14px;
      font-weight: 700;
    }
  }
  &.black {
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0 0 1px 1px #bbbec8;
    .text {
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      color: #191F2D;
    }
    .hot-key {
      text-align: center;
      margin: 0.5rem;
      border-radius: 4px;
      background: #ECF4FE;
      color: rgba(25, 31, 45, 1);
      font-size: 14px;
      font-weight: 700;
    }
  }
  ul {
    padding: 0.5rem;
    padding-bottom: 0px;
    display: grid;
    list-style: none;
    li {
      display: flex;
      .icon {
        float: left;
        margin-bottom: auto;
      }
    }
  }
}

.effect-item-disable {
  cursor: initial;
  pointer-events: none;
  opacity: 0.2;
  &:hover {
    background: initial;
  }
}

.effect-item {
  cursor: pointer;
  display: grid;
  width: 100%;
  grid-template-columns: 17% 66% 17%;
  border-radius: 8px;
  align-items: center;
  &:hover {
    background: rgba(206,206,206, 0.2);
  }
}

.effect-header {
  display: grid;
  width: 100%;
  grid-template-columns: 17% 83%;
  padding: 0.5rem;
  &.white {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  &.black {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  grid-template-columns: 17% 83%;
  align-items: center;
  cursor: initial;
}

.effect-tooltip {
  position: absolute;
  display: inline-block;
  font-size: 12px!important;
  line-height: 18px;
  padding: 5px 10px 4px;
  background: #282E3E;
  color: #FFFFFF;
  border-radius: 4px;
  z-index: 300;
  bottom: 3.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;

  .effect--tooltip__tip {
    position: absolute;
    width: 11px;
    z-index: 1;
    font-size: 14px;
    height: 11px;
    bottom: -5px;
    right: calc(50% - 11px);
    background: #282E3E;
    transform: translate(-50%, 0) rotate(45deg);
    border-bottom-right-radius: 2px;
    outline: none;
  }
}
</style>
